import Vue from "vue";

const state = { errors: [] };

const getters = {
  getAllErrors: (state) => state.errors,
};

const actions = {
  setError({ commit }, payload) {
    try {
      commit("SET_ERROR", payload);
    } catch (e) {
      console.log(e);
    }
  },
  dismissAllErrors({ commit }, payload) {
    try {
      commit("DISMISS_ALL_ERRORS", payload);
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  SET_ERROR: (state, payload) => {
    var errors = [...state.errors];
    errors.push(payload);
    Vue.set(state, "errors", errors);
  },
  DISMISS_ALL_ERRORS: (state) => {
    Vue.set(state, "errors", []);
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
